<style scoped lang="less">
.content {
  background-color: #f0f2f5;
  text-align: left;
}

.bottom {
  margin-top: 15px;
}

.pageContent {
  text-align: right;
  padding-top: 20px;
}

.num-info {
  .title {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    height: 22px;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
  }

  .value {
    .total {
      color: rgba(0, 0, 0, 0.85);
      display: inline-block;
      line-height: 32px;
      height: 32px;
      font-size: 24px;
      margin-right: 32px;
    }

    .subtotal {
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      vertical-align: top;
      margin-right: 0;

      i {
        font-size: 22px;
        color: red;
        transform: scale(0.82);
        margin-left: 4px;
      }
    }
  }
}

#chart,
#myChart {
  width: 100%;
  height: 100px;
  margin: auto;
  top: -10px;
}

#search,
#search1 {
  height: 100px;
}

#pie {
  height: 350px;
}

#sale,
#scan,
#chargeChart {
  height: 350px;
}

.ivu-divider-horizontal {
  margin: 10px 0;
}

.txt-left {
  text-align: left;

  .title,
  a {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }

  .num {
    font-size: 30px;
    color: #000;
    margin-bottom: 10px;
  }

  .des,
  .footer {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;

    i {
      font-size: 22px;
      margin-right: 10px;
    }
  }

  .des {
    margin-top: 23px;
  }

  .chart_divider {
    margin-top: -55px;
  }

  .progress {
    margin: 8px 0;
  }
}

.tab {
  margin-top: 15px;
  padding: 20px 10px 15px;
  background-color: #fff;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }

  .title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
  }
}
.extra-item a {
  color: initial;
}
.search {
  color: #2d8cf0 !important;
}
</style>
<template>
  <!--分析页-->
  <div class="content">
    <h1 v-if="roleCode == 'closeFrontpage'">你好，请选择左侧导航栏进行操作</h1>
    <Row
      class="txt-left"
      :gutter="12"
      v-if="roleCode != 'closeFrontpage'"
      style="display: flex"
    >
      <Col span="6">
        <Card>
          <p>
            订单数量&ensp;<span class="num">{{ orderCount }}</span>
          </p>
          <p>
            报名人数&ensp;<span class="num">{{ peopleCount }}</span>
          </p>
          <!-- <a href="javascript:;" slot="extra">
            <Tooltip content="指标说明" placement="bottom">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </a> -->
          <!-- <div class="des" >
                         同周比 12%
                         <Icon type="md-arrow-dropup" color="#f5222d"/>
                         日环比 11%
                         <Icon type="md-arrow-dropdown" color="#52c41a"/>
                     </div>-->
          <div id="search"></div>
          <Divider class="chart_divider" />
          <p>今日订单数量 {{ orderCountToday }}</p>
        </Card>
      </Col>
      <Col span="6">
        <Card>
          <p>总销售额</p>
          <a href="javascript:;" slot="extra">
            <Tooltip content="指标说明" placement="top">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </a>
          <p class="num">￥ {{ orderAmount | moneyFilter }}</p>
          <div id="chart"></div>
          <Divider class="chart_divider" />
          <p>今日销售额 {{ orderAmountToday | moneyFilter }}</p>
        </Card>
      </Col>
      <Col span="6">
        <Card>
          <p>学员数量</p>
          <a href="javascript:;" slot="extra">
            <Tooltip content="指标说明" placement="top">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </a>
          <p class="num">{{ userCount }}</p>
          <div id="myChart"></div>
          <Divider class="chart_divider" />
          <p>今日注册数量 {{ userCountByToday }}</p>
        </Card>
      </Col>

      <Col span="6">
        <Card>
          <p>转换评价数量</p>
          <a href="javascript:;" slot="extra">
            <Tooltip content="指标说明" placement="top">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </a>
          <p class="num">{{ certificateConversionNum }}</p>
          <Progress :percent="0" status="success" hide-info class="progress" />
          <Divider />
          <div class="footer">
            <el-date-picker
              size="mini"
              v-model="searchCondition.certificateConversionRangeTime"
              type="daterange"
              unlink-panels
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="
                (value) => {
                  [
                    searchCondition.certificateConversionBeginTime,
                    searchCondition.certificateConversionEndTime,
                  ] = value || ['', ''];
                  getCertificateConversionNum();
                }
              "
            >
            </el-date-picker>
            <!-- <Icon type="md-arrow-dropup" color="#f5222d"/>
                        日环比 11%
                        <Icon type="md-arrow-dropdown" color="#52c41a"/>-->
          </div>
        </Card>
      </Col>
      <!-- <Col span="6" v-if="roleCode == 'all'">
        <Card>
          <p>课程数量</p>
          <a href="javascript:;" slot="extra">
            <Tooltip content="指标说明" placement="top">
              <Icon type="ios-information-circle-outline" />
            </Tooltip>
          </a>
          <p class="num">{{ courseCount }}</p>
          <Progress :percent="0" status="success" hide-info class="progress" />
          <Divider />
          <div class="footer">
            讲师数量 {{ lectureCount }}
            <Icon type="md-arrow-dropup" color="#f5222d"/>
                        日环比 11%
                        <Icon type="md-arrow-dropdown" color="#52c41a"/>
          </div>
        </Card>
      </Col> -->
    </Row>
    <div class="tab" v-if="roleCode != 'closeFrontpage'">
      <Tabs>
        <div class="extra-wrap" slot="extra">
          <!--  <div class="extra-item">
                        <a>今日</a>
                        <a>本周</a>
                        <a>本月</a>
                        <a>本年</a>
                    </div>-->
          <!--<DatePicker type="daterange" placement="bottom-end" placeholder="开始日期 - 结束日期"></DatePicker>-->
        </div>
        <TabPane label="订单月统计">
          <Row>
            <Col span="15">
              <div id="sale"></div>
            </Col>
            <Col span="9">
              <p class="title">课程销售排行榜</p>
              <rakinglist :list="rankList"></rakinglist>
            </Col>
          </Row>
        </TabPane>
        <!--  <TabPane label="VIP统计">
                    <Row>
                        <Col span="15">
                            <p class="title">VIP开通趋势</p>
                            <div id="scan"></div>
                        </Col>
                        <Col span="9">
                            <p class="title">门店销售排行榜</p>
                            <rakinglist :list="rankList"></rakinglist>
                        </Col>
                    </Row>
                </TabPane>-->
      </Tabs>
    </div>
    <Row :gutter="15" class-name="bottom" v-if="roleCode != 'closeFrontpage'">
      <Col span="24">
        <Card>
          <div
            style="
              height: 48px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span>报名统计</span>
            <div>
              <el-date-picker
                size="small"
                v-model="replyRangeTime"
                type="daterange"
                unlink-panels
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="
                  (value) => {
                    [
                      reportCountSearchCondition.payBeginTime,
                      reportCountSearchCondition.payEndTime,
                    ] = value || ['', ''];
                  }
                "
              >
              </el-date-picker>
              &ensp;&ensp;
              <el-button type="primary" size="small" @click="getData"
                >查询</el-button
              >
            </div>
          </div>

          <Table
            border
            :columns="columns5"
            :data="data5"
            @on-sort-change="changeSort"
            sortable="custom"
          ></Table>
          <div>
            合计：<br />
            报名总人次：
            <!-- {{
              data5.reduce((total, item, idx, arr) => {
                if (item.examStatusNow == 2) {
                  total += Number(item.nop);
                }
                return total;
              }, 0)
            }} -->
            {{ searchMap.orderCount }}
            &emsp;&emsp;报名总金额：{{ searchMap.orderAmount }}
            <!-- {{
              data5.reduce((total, item, idx, arr) => {
                if (item.examStatusNow == 2) {
                  total += Number(item.amount);
                }
                return total;
              }, 0)
            }} -->
            &emsp;&emsp;报名总人数：{{ searchMap.peopleCount }}
          </div>
          <div class="pageContent">
            <Page
              :current="searchForm.pageNumber"
              :total="total"
              :page-size="searchForm.pageSize"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
              :page-size-opts="[10, 20, 50]"
              size="small"
              show-total
              show-elevator
              show-sizer
            >
            </Page>
          </div>
        </Card>
      </Col>
      <!--<Col span="12">
                <Card>
                    <p slot="title">销售额占比</p>
                    <a href="javascript:;" slot="extra">
                        <Icon type="ios-more"/>
                    </a>
                    <div>
                        <ButtonGroup size="large">
                            <Button>全渠道</Button>
                            <Button>线上</Button>
                            <Button>门店</Button>
                        </ButtonGroup>
                    </div>
                    <div id="pie"></div>
                </Card>
            </Col>-->
    </Row>
    <div class="tab" v-if="roleCode != 'closeFrontpage'">
      <Tabs>
        <div class="extra-wrap" slot="extra">
          <div class="extra-item">
            <a
              :class="searchType == 'all' ? 'search' : ''"
              v-on:click="tagChoose('all')"
              >总计</a
            >&nbsp;&nbsp;&nbsp;
            <a
              :class="searchType == 'today' ? 'search' : ''"
              v-on:click="tagChoose('today')"
              >今天</a
            >&nbsp;&nbsp;&nbsp;
            <a
              :class="searchType == 'yesterday' ? 'search' : ''"
              v-on:click="tagChoose('yesterday')"
              >昨天</a
            >&nbsp;&nbsp;&nbsp;
          </div>
          <DatePicker
            type="daterange"
            split-panels
            placement="bottom-end"
            placeholder="选择时间范围"
            @on-change="selectDateRange"
          ></DatePicker>
          &nbsp;&nbsp;&nbsp;
          <Button type="primary" @click="handelSubmit" style="width: 80px"
            >搜索</Button
          >
        </div>
        <TabPane label="收费统计">
          <Row>
            <Col span="24">
              <div id="chargeChart"></div>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
    </div>
    <examinationManage
      v-if="roleCode != 'closeFrontpage'"
      ref="examinationManage"
    ></examinationManage>
    <educationManage
      v-if="roleCode != 'closeFrontpage'"
      ref="educationManage"
    ></educationManage>
  </div>
</template>
<script>
import educationManage from "./record/educationManage";
import examinationManage from "./record/examinationManage";
import rakinglist from "./rakinglist";
import Cookies from "js-cookie";

import {
  homereport,
  searchOrder,
  searchExam,
  certificateConversionNum,
} from "@/api/index";
//import echarts from 'echarts'
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
const rankList = [];

export default {
  name: "",
  props: {},
  data() {
    return {
      searchMap: { orderAmount: 0, orderCount: 0, peopleCount: 0 },
      peopleCount: 0,
      replyRangeTime: [],
      roleCode: "closeFrontpage",
      userCountByToday: 0,
      userCount: 0,
      orderCountToday: 0,
      orderAmountToday: 0,
      orderCount: 0,
      orderAmount: 0,
      courseCount: 0,
      lectureCount: 0,
      sale_amounts: [],
      sale_dates: [],
      year_amounts: [],
      sale_nums: [],
      user_nums: [],
      chargeList: [],
      rankList: [
        {
          name: "",
          total: "",
        },
      ],
      beginTime: "",
      endTime: "",
      searchType: "all",
      columns5: [
        {
          title: "考试名称",
          align: "center",
          key: "examName",
        },
        {
          title: "报考开始时间",
          align: "center",
          key: "applyBeginDate",
        },
        {
          title: "报考结束时间",
          align: "center",
          key: "applyEndDate",
        },
        {
          title: "报名总人次",
          align: "center",
          key: "nop",
        },
        {
          title: "报名总金额",
          align: "center",
          key: "amount",
          render: (h, params) => {
            let re = "0";
            if (params.row.amount != "") {
              re = params.row.amount;
            }
            return h("div", re);
          },
        },
        {
          title: "报名状态",
          align: "center",
          key: "examStatusNow",
          render: (h, params) => {
            let re = "";
            if (params.row.examStatusNow == 1) {
              return h("div", [
                h(
                  "Tag",
                  {
                    props: {
                      color: "blue",
                    },
                  },
                  "未开始"
                ),
              ]);
            } else if (params.row.examStatusNow == 2) {
              return h("div", [
                h(
                  "Tag",
                  {
                    props: {
                      color: "green",
                    },
                  },
                  "进行中"
                ),
              ]);
            } else if (params.row.examStatusNow == 3) {
              return h("div", [
                h(
                  "Tag",
                  {
                    props: {
                      color: "grey",
                    },
                  },
                  "已结束"
                ),
              ]);
            } else {
              return h("div", "--");
            }
          },
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.exaTime(params.row);
                    },
                  },
                },
                "查看报名详情"
              ),
            ]);
          },
        },
      ],
      data5: [],
      total: 0, // 表单数据总数
      searchForm: {
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
      },
      reportCountSearchCondition: {
        payBeginTime: "",
        payEndTime: "",
      },
      searchCondition: {
        certificateConversionBeginTime: "",
        certificateConversionEndTime: "",
        certificateConversionRangeTime: [],
      },
      certificateConversionNum: 0,
    };
  },
  methods: {
    changeSort(e) {
      console.log(e);
      // this.searchForm.sort = e.key;
      // this.searchForm.order = e.order;
      // if (e.order === "normal") {
      //   this.searchForm.order = "";
      // }
      // this.getData();
    },
    exaTime(v) {
      if (v.examType == 1) {
        this.$refs.educationManage.showDrawer(v);
      } else {
        this.$refs.examinationManage.showDrawer(v);
      }
    },
    selectDateRange(v) {
      if (v) {
        this.beginTime = v[0];
        this.endTime = v[1];
      }
    },
    tagChoose(v) {
      this.searchType = v;
      searchOrder({ type: this.searchType }).then((res) => {
        this.chargeList = res.data.orderList;
        let chargeChart = echarts.init(document.getElementById("chargeChart"));
        chargeChart.setOption(this.chargeChart_opt());
      });
    },
    handelSubmit() {
      this.searchType = "section";
      searchOrder({
        type: this.searchType,
        beginTime: this.beginTime,
        endTime: this.endTime,
      }).then((res) => {
        this.chargeList = res.data.orderList;
        let chargeChart = echarts.init(document.getElementById("chargeChart"));
        chargeChart.setOption(this.chargeChart_opt());
      });
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.searchExam();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.searchExam();
    },
    searchExam() {
      searchExam(this.searchForm).then((res) => {
        if (res.status === true) {
          this.data5 = res.data.rows;
          this.total = res.data.total;
        }
      });
    },
    getCertificateConversionNum() {
      certificateConversionNum({
        beginTime: this.searchCondition.certificateConversionBeginTime,
        endTime: this.searchCondition.certificateConversionEndTime,
      }).then((data) => {
        this.certificateConversionNum = data.data;
        // console.log(data);
      });
    },
    getData() {
      homereport(this.reportCountSearchCondition).then((res) => {
        console.info(res.data);
        if (res.data == "closeFrontpage") {
          this.roleCode = "closeFrontpage";
        } else {
          if (res.status === true) {
            this.userCountByToday = res.data.userCountByToday;
            this.userCount = res.data.userCount;
            this.orderCountToday = res.data.orderCountToday;
            this.orderAmountToday = res.data.orderAmountToday;
            this.orderCount = res.data.orderCount;
            this.orderAmount = res.data.orderAmount;
            this.sale_dates = res.data.sale_dates;
            this.sale_nums = res.data.sale_nums;
            this.user_nums = res.data.user_nums;
            this.sale_amounts = res.data.sale_amounts;
            this.year_amounts = res.data.year_amounts;
            this.courseCount = res.data.courseCount;
            this.lectureCount = res.data.lectureCount;
            this.rankList = res.data.courseList;
            this.chargeList = res.data.orderList;
            this.data5 = res.data.examList.rows;
            this.total = res.data.examList.total;
            this.peopleCount = res.data.peopleCount;
            this.searchMap = res.data.examList.map;
            this.draw();
            this.roleCode = "";
          }
        }
      });
    },
    draw() {
      //销售额统计
      let myChart = echarts.init(document.getElementById("chart"));
      myChart.setOption(this.amount_opt());
      //搜索线形图
      let lineChart = echarts.init(document.getElementById("search"));
      lineChart.setOption(this.opt());
      /*  //搜索线形图
                  let lineChart1 = echarts.init(document.getElementById('search1'))
                  lineChart1.setOption(this.opt());*/
      //顶部 柱状图
      let chart = echarts.init(document.getElementById("myChart"));
      chart.setOption({
        color: ["#3aa0ff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          top: "0",
          containLabel: false,
        },
        xAxis: [
          {
            show: false,
            type: "category",
            data: this.sale_dates,
          },
        ],
        yAxis: [
          {
            show: false,
            type: "value",
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            data: this.user_nums,
          },
        ],
      });
      //tab柱状图(销售)
      let bar = echarts.init(document.getElementById("sale"));
      bar.setOption(this.option());
      //销售额统计
      let chargeChart = echarts.init(document.getElementById("chargeChart"));
      chargeChart.setOption(this.chargeChart_opt());
      /*  //tab柱状图(访问量)
                let bar_scan = echarts.init(document.getElementById('scan'))
                bar_scan.setOption(this.option())*/
      /* //      饼状图
                let pie = echarts.init(document.getElementById('pie'))
                pie.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'right',
                        y: 'bottom',
                        data: ['直达', '邮件营销', '联盟广告', '视频广告', '百度']
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: ['40%', '55%'],
                            label: {
                                normal: {
                                    formatter: '  {b}：{d}%  ',

                                    borderWidth: 1,
                                    borderRadius: 4,
                                    label: {

                                        fontSize: 16,
                                        lineHeight: 33


                                    }
                                }
                            },
                            data: [
                                {value: 335, name: '直达'},
                                {value: 310, name: '邮件营销'},
                                {value: 234, name: '联盟广告'},
                                {value: 135, name: '视频广告'},
                                {value: 1048, name: '百度'},
                            ],
                            itemStyle: {
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            '#3aa1ff', '#36cbcb', '#4ecb73', '#Fbd437', '#F2637b'
                                        ];
                                        return colorList[params.dataIndex]
                                    }
                                }
                            }
                        }
                    ]
                });*/
    },
    chargeChart_opt() {
      let option = {
        color: "#3398DB",
        title: {
          text: "世界人口总量",
          subtext: "数据来自网络",
        },

        grid: {
          left: "3%",
          right: "4%",
          top: "1%",
          bottom: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: [
            "充值",
            "线下课程购买",
            "直播课程购买",
            "能力测评购买",
            "vip购买",
            "在线课程购买",
            "继续教育收费",
            "考试报名收费",
          ],
        },
        series: [
          {
            barWidth: "50%", //柱粗细
            type: "bar",
            label: {
              show: true, //柱子上数字是否显示
              position: "right", //柱子上数字显示位置
            },
            data: this.chargeList,
          },
        ],
      };
      return option;
    },
    option() {
      let opt = {
        color: ["#3aa0ff"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          containLabel: false,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            data: this.year_amounts,
          },
        ],
      };
      return opt;
    },
    //订单数量统计
    opt() {
      let param = {
        color: "#b8ddff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          top: "0",
          containLabel: false,
        },
        xAxis: [
          {
            show: false,
            type: "category",
            boundaryGap: false,
            data: this.sale_dates,
          },
        ],
        yAxis: [
          {
            type: "value",
            show: false,
          },
        ],
        series: [
          {
            type: "line",
            label: {
              normal: {
                show: false,
              },
            },
            areaStyle: {
              normal: {
                color: "#b8ddff",
              },
            },
            smooth: "max",
            smoothMonotone: "max",
            sampling: "max",
            data: this.sale_nums,
          },
        ],
      };
      return param;
    },
    //订单数量统计
    amount_opt() {
      let param = {
        color: "#b8ddff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          top: "0",
          containLabel: false,
        },
        xAxis: [
          {
            show: false,
            type: "category",
            boundaryGap: false,
            data: this.sale_dates,
          },
        ],
        yAxis: [
          {
            type: "value",
            show: false,
          },
        ],
        series: [
          {
            type: "line",
            label: {
              normal: {
                show: false,
              },
            },
            areaStyle: {
              normal: {
                color: "#b8ddff",
              },
            },
            smooth: "max",
            smoothMonotone: "max",
            sampling: "max",
            data: this.sale_amounts,
          },
        ],
      };
      return param;
    },
  },
  mounted() {
    this.getData();
    this.roleCode = JSON.parse(Cookies.get("userInfo")).roles[0].code;
  },
  created() {},
  components: {
    rakinglist,
    educationManage,
    examinationManage,
  },
};
</script>
